import React from "react";
import { TableLoader, TableModel } from "../../components/tableLoader";
export { Practice };
/** 
 * Страница Портфолио / Практики
 */
function Practice({ }) {
  const loader =
  {
    title: "Практики",
    icon: "survey",
    request:
    {
      method: "post",
      path: "/student/portfolio/practices",
      data: {}
    }
  };
  return <TableLoader {...loader} />;
}